import type {RutaProd} from '../../../../runtime/rutas';
export default {"ruta": "/sistema/catalogos/productos/importar", "documento": "catalogs", "acceso": "sesion", "filas": ["169"], "cita": "Areas/Catalogs/Controllers/ProductImportController.cs"} satisfies RutaProd;
